import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { applyMiddleware, createStore, compose } from "redux";
import rootReducer from "./reducers/rootReducer";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import thunkMiddleware from "redux-thunk";
import { logger } from "redux-logger";
import "./resources/enhanced-forms.css";
import { initializeApi } from "./resources/api";
import { shortCode } from "./resources/constants";

const APP_VERSION = '1.0.1';
const STORAGE_KEY = 'persist:' + shortCode.toLowerCase() + '_staff_';
const VERSION_KEY = shortCode.toLowerCase() + '_staff_version';

if (localStorage.getItem(VERSION_KEY) !== APP_VERSION) {
  localStorage.removeItem(STORAGE_KEY);
  document.cookie.split(';').forEach((c) => {
    document.cookie = c.trim().replace(/=.*/, '=;expires=' + new Date(0).toUTCString() + ';path=/');
  });
  localStorage.setItem(VERSION_KEY, APP_VERSION);
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let store;
// Only include redux-logger in development mode
// if (process.env.NODE_ENV === 'development') {
//   store = createStore(
//     rootReducer,
//     composeEnhancers(applyMiddleware(logger, thunkMiddleware))
//   );
// } else {
store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunkMiddleware))
);
// }

// Initialize API client with store for automatic token injection
initializeApi(store);

const persist = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persist}>
      <App />
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
